import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  personPhone?: string;
  personId?: string;
  selectedGroupParticipantId?: string;
  isNew?: boolean;
  locationPhone?: string;
  threadItemId?: string;
  threadItemCreatedAt?: string;
  click?: number;
  isArchived?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/messages/$filter/$groupId_/$threadId')({
  staticData: { team: 'fe-messaging' },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    //TODO: validate any of these search params validity
    return search;
  },
});
